/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {TextMaskConfig} from '../../../ui/legacy-text-mask';
import {AbstractField} from '../abstract-field';
import {EmpZoneDependency} from "@gp/shared/form-generator/form-generator.interfaces";

/**
 * An input type text on one line type of field
 */
@Component({
  selector: 'gp-form-field-text',
  template: `
    <input type="text"
           class="form-control"
           [attr.test-id]="descriptor.zoneID"
           [class.gp-error]="descriptor.isRequired && descriptor.readOnly && !value.value"
           [formControl]="control"
           [attr.readOnly]="readOnly ? 'true' : null"
           [(ngModel)]="value.value"
           (focus)="onFocus()"
           [textMask]="textMask"
           [attr.placeholder]="descriptor.type === 'AUTO_GENERATED' ? ('FORMS.generated' | translate) : null"
           (blur)="onBlur()"
    >
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextFieldComponent extends AbstractField implements OnInit {

  public textMask: TextMaskConfig = null;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    if (this.descriptor && this.descriptor.inputMask) {
      this.textMask = {
        guide: true,
        mask: this.descriptor.inputMask.split('').map(s => s === 's' ? /./ : s),
        showMask: false
      };
    } else {
      this.textMask = {
        mask: false
      };
    }

    if (this.descriptor.type === 'LABEL') {
      this.bindDependencyTriggered();
    }
  }

  protected afterDependencyHandled(_dependency: EmpZoneDependency) {
    this.cd.markForCheck();
  }

}
